<template>
    <!-- LETODO - convert in render function so can pass props from vue-fileds to child component -->
    <div class='v-field form-group' :class="{error:error}">

            <!-- LETODO - check a better way to define when label is show or not?  Maybe need puts all render in fields? -->
           <label v-if="type.toLowerCase()!='boolean'" for="inputEmail3" class="fw9 "> <span v-if="required==true" class='f5 '>*</span>{{ label }}:  </label>  
           <div class="">
                <field-string :is="'field-'+type.toLowerCase()" :disabled="disabled" :mask="mask" ref="input" :name="name" :label="label" :value="myValue" :options="options" @change="updateValue" @input="inputValue" @blur="blur" />
                <small class="form-text text-muted">
                     {{ helptext }}
                </small>
                <div v-if="error" class='filed-message error red'>
                    {{ errormsg[0] }}
                </div>
          </div>
    

    </div>

</template>

<script>
import _ from 'lodash';
import validatorFuncs from './field-validations.js';

export default {
    name:"vue-field",
    inheritAttrs:false,
    props:{
        // formName:{
        //     default:''
        // },
        name:{
            required:true
        },
        mask:{
            default:false
        },
        label:{
            default:''
        },
        helptext:{
            default:''
        },
        value:{
            default:''
        },
        validations:{
            // type:Array,
            default:()=>[]
        },
        validation:{
            // type:String,
            default:undefined
        },
        required:{
            type:Boolean,
            default:false
        },
        type:{
            default:'string'
        },
        options:{
            default:()=>[]
        },
        disabled:{
            type:Boolean,
            default:false
        }
    },
    data(){
        return {
            error:false,
            errormsg:[],
            _validators:[],
            min:null,
            max:null,
        }
    },

    watch:{
        errormsg:function(val){
            if( _.isEmpty(val) ){
                this.error = false;
            }else{
                this.error = true;
            }
            this.$emit('error',{name:this.name, error:this.error})
        },
        value:function(){
            
            this.$forceUpdate();
        }
    },

    computed:{
        //this is a value from the store, cause wi work with the storys
        myValue:{
            get:function(){
                return this.$store.getters.valueForFormField(this.formName, this.name)  
            },
            set:function(val){
                this.$store.commit('updateValueForFormField',{formName:this.formName, key:this.name, value:val })  
            }
        },

        parentForm:function(){
            let parent = this.$parent;
            while(parent){
                if(parent.$vnode.componentOptions.tag == 'vue-form'){
                    break
                }else{
                    parent = _.get(parent,'$parent',undefined)
                }
            }
            return parent
        },

        formName:function(){
            return _.get(this.parentForm,'$props.name','')
        },

        initialValue:function(){
           
            let myvalue =  _.get(this,`$props.value`)
            let valuFromVModel =  _.get(this.parentForm,`$props.value[${this.name}]`,'')
            console.log('this.name',this.name)
            console.log('myvalue',myvalue)
            console.log('valuFromVModel',valuFromVModel)
            if(typeof myvalue === 'boolean'){
                return myvalue
            }
            if( ! _.isEmpty(myvalue) ) return myvalue
            return valuFromVModel;
        },

    },

    created:function(){
        //create in store this field
        this.$store.commit('addField',{formName:this.formName, fieldName:this.name, value:this.initialValue})
        if(this.required){
            this.$data._validators = ["required"]
        }
        let allvalidations = this.validations;
        if(this.validation) allvalidations.push(this.validation)
        _.each(allvalidations, val=>{
            if( _.isString(val) ){
                this.$data._validators.push(val)
            }
            if(_.isArray(val)){
                if(val.length == 3){
                        this.$data._validators.push(val[0])
                        this.min = val[1]
                        this.max = val[2]
                }
            }
            if(_.isFunction(val)){
                this.$data._validators.push(val)
            }
        })
    },

    beforeDestroy () {
        this.$store.commit('removeField',{formName:this.formName, fieldName:this.name})
    },

    methods:{

        inputValue:function(val){
            
            this.myValue = val;
            if(this.error){
                this.updateValue(val)
                // this.runValidations(val)
            }
            this.$emit('input',val)
        },

        blur:function(val){
           this.$emit('blur',val)
        },

        updateValue:function(val){
            
            // let val = this.$refs.input.value;
            this.myValue = val;
            this.runValidations(val)
            //  console.log('vue-field:' + val)
            this.$emit('change',val)
            this.$emit('input',val)
        },

        validate:async function(){
            return this.runValidations();
        },
        runValidations:async function(){
            let val = this.myValue;
            this.error = false;
            this.errormsg = [];
            for (let i = 0; i < this.$data._validators.length; i++) {
                const validator = this.$data._validators[i];
                if( _.isString(validator) ){
                    var func = _.get(validatorFuncs,validator)
                    if( _.isFunction(func) ){
                       let erro = func(val,this)  
                       if(erro){
                           this.errormsg = erro
                       }
                    }
                }
                if( _.isFunction(validator) ){
                     let erro = validator(val)  
                     if(erro){
                           this.errormsg = erro
                     }
                }
            }

             if( _.isEmpty(this.errormsg) ){
                return true;
            }else{
                return false;
            }
        },
    }

}
</script>

<style lang="stylus">

        .v-field.error{
            label{
                color:red;
            }
            .form-control{
                border-color:red;
            }

        }

</style>
